module.exports = __webpack_public_path__ + "static/media/student.c36d6046.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/student.jpg
// module id = 32
// module chunks = 0